// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================
   Case Study Section
   =========================== */
.cs-section {
  padding: 80px 0 60px;
  background: #fff;
}

/* Section Heading */
.cs-section-heading {
  font-size: var(--font-size-xxxlarge, 40px);
  font-weight: var(--font-bold, 700);
  font-family: var(--font-montserrat-bold, 'Montserrat', sans-serif);
  line-height: 1.2;
  margin-bottom: 36px;
}

.cs-heading-purple {
  color: #6318C6;
}

.cs-heading-black {
  color: #070707;
}

/* ===========================
   Main Card
   =========================== */
.cs-card {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* ===========================
   Case Study Image (Left)
   =========================== */
.cs-image-wrap {
  padding: 0px;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs-main-image {
  max-width: 100%;
  height: auto;
  /* box-shadow: 0 8px 30px 0 rgba(0, 0, 0, 0.12); */
  border-radius: 12px;
}

/* ===========================
   Right Content
   =========================== */
.cs-content {
  padding: 5px 35px 20px 0px;
}

/* Badge */
.cs-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(90deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);
  color: #6318C6;
  font-size: 14px;
  font-weight: 500;
  /* Medium */
  font-family: var(--font-montserrat-medium, 'Montserrat', sans-serif);
  border-radius: 100px;
  /* Pillow shape for 100% roundness with fixed height */
  height: 40px;
  padding: 0 20px;
  margin-bottom: 22px;
}

.cs-verified-icon {
  width: 18px;
  height: 18px;
}

/* Impact Box */
.cs-impact-box {
  background: linear-gradient(90deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);
  border-radius: 20px;
  padding: 15px 20px;
  margin-bottom: 25px;
}

.cs-impact-title {
  font-size: 20px;
  font-weight: 600;
  /* Semibold */
  color: #0D0D0D;
  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);
  margin-bottom: 8px;
}

.cs-impact-text {
  font-size: 17px;
  font-weight: 400;
  /* Regular */
  color: #0D0D0D;
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  line-height: 1.6;
  margin: 0;
}

/* Brand Name */
.cs-brand-name {
  font-size: 28px;
  font-weight: 600;
  /* Semibold */
  color: #0D0D0D;
  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);
  margin-bottom: 8px;
}

.cs-brand-desc {
  font-size: 17px;
  font-weight: 400;
  /* Regular */
  color: #121A2C;
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  line-height: 1.6;
  margin-bottom: 24px;
}

/* Two-col Lists */
.cs-lists-row {
  margin-bottom: 24px;
}

.cs-list-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  /* Semibold */
  color: #0D0D0D;
  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);
  margin-bottom: 20px;
}

.cs-list-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cs-list-icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cs-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cs-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  font-weight: 400;
  /* Regular */
  color: #0D0D0D;
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  line-height: 1.5;
  margin-bottom: 10px;
}

.cs-bullet {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 7px;
}

.cs-bullet-purple {
  background-color: #6318C6;
}

.cs-bullet-orange {
  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);
}

/* Solution */
.cs-solution {
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
}

.cs-solution-label {
  font-size: 16px;
  font-weight: 600;
  /* Semibold */
  color: #0D0D0D;
  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);
  display: block;
  margin-bottom: 8px;
}

.cs-solution-text {
  font-size: 16px;
  font-weight: 400;
  /* Regular */
  color: #0D0D0D;
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  line-height: 1.65;
  margin: 0;
}

/* ===========================
   Responsive
   =========================== */
@media (max-width: 991px) {
  .cs-image-wrap {
    padding: 0px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    min-height: auto;
  }

  .cs-content {
    padding: 12px 10px 10px 10px;
  }
}

@media (max-width: 767px) {
  .cs-impact-title {
    font-size: 16px;
    margin-bottom: 5px !important;
  }

  .cs-lists-row {
    margin-bottom: 10px;
  }

  .cs-solution-text {
    font-size: 14px;
  }

  .cs-solution {
    padding-top: 10px;
  }

  .cs-list {
    padding: 0 0 0 25px;
  }

  .cs-badge {
    margin-bottom: 11px;
  }

  .cs-list-heading {
    margin-bottom: 10px;
  }

  .cs-card {
    border: none;
    box-shadow: none;
  }

  .cs-section {
    padding: 50px 0 4px;
  }

  .cs-section-heading {
    font-size: var(--font-size-regular);
    margin-bottom: 24px;
    text-align: center;
  }

  .cs-brand-name {
    font-size: 20px;
  }

  .cs-brand-desc {
    font-size: 14px;
  }

  .cs-impact-text {
    font-size: 14px;
  }
}

@media (min-width: 768px) and (max-width: 1280px) {
  .cs-content {
    padding: 24px 35px 20px 0px !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .cs-content {
    padding: 24px 35px 20px 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/CaseStudy/CaseStudy.css"],"names":[],"mappings":"AAAA;;gCAEgC;AAChC;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,kEAAkE;EAClE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;gCAEgC;AAChC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;gCAEgC;AAChC;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;gCAEgC;AAChC;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0FAA0F;EAC1F,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oEAAoE;EACpE,oBAAoB;EACpB,sDAAsD;EACtD,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,0FAA0F;EAC1F,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,6DAA6D;EAC7D,gBAAgB;EAChB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,6DAA6D;EAC7D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,6DAA6D;EAC7D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,aAAa;AACb;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sEAAsE;EACtE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;EACjB,SAAS;AACX;;AAEA;;gCAEgC;AAChC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF","sourcesContent":["/* ===========================\n   Case Study Section\n   =========================== */\n.cs-section {\n  padding: 80px 0 60px;\n  background: #fff;\n}\n\n/* Section Heading */\n.cs-section-heading {\n  font-size: var(--font-size-xxxlarge, 40px);\n  font-weight: var(--font-bold, 700);\n  font-family: var(--font-montserrat-bold, 'Montserrat', sans-serif);\n  line-height: 1.2;\n  margin-bottom: 36px;\n}\n\n.cs-heading-purple {\n  color: #6318C6;\n}\n\n.cs-heading-black {\n  color: #070707;\n}\n\n/* ===========================\n   Main Card\n   =========================== */\n.cs-card {\n  background: #fff;\n  border-radius: 24px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n/* ===========================\n   Case Study Image (Left)\n   =========================== */\n.cs-image-wrap {\n  padding: 0px;\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cs-main-image {\n  max-width: 100%;\n  height: auto;\n  /* box-shadow: 0 8px 30px 0 rgba(0, 0, 0, 0.12); */\n  border-radius: 12px;\n}\n\n/* ===========================\n   Right Content\n   =========================== */\n.cs-content {\n  padding: 5px 35px 20px 0px;\n}\n\n/* Badge */\n.cs-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(90deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);\n  color: #6318C6;\n  font-size: 14px;\n  font-weight: 500;\n  /* Medium */\n  font-family: var(--font-montserrat-medium, 'Montserrat', sans-serif);\n  border-radius: 100px;\n  /* Pillow shape for 100% roundness with fixed height */\n  height: 40px;\n  padding: 0 20px;\n  margin-bottom: 22px;\n}\n\n.cs-verified-icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* Impact Box */\n.cs-impact-box {\n  background: linear-gradient(90deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);\n  border-radius: 20px;\n  padding: 15px 20px;\n  margin-bottom: 25px;\n}\n\n.cs-impact-title {\n  font-size: 20px;\n  font-weight: 600;\n  /* Semibold */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);\n  margin-bottom: 8px;\n}\n\n.cs-impact-text {\n  font-size: 17px;\n  font-weight: 400;\n  /* Regular */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Brand Name */\n.cs-brand-name {\n  font-size: 28px;\n  font-weight: 600;\n  /* Semibold */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);\n  margin-bottom: 8px;\n}\n\n.cs-brand-desc {\n  font-size: 17px;\n  font-weight: 400;\n  /* Regular */\n  color: #121A2C;\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  line-height: 1.6;\n  margin-bottom: 24px;\n}\n\n/* Two-col Lists */\n.cs-lists-row {\n  margin-bottom: 24px;\n}\n\n.cs-list-heading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  /* Semibold */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);\n  margin-bottom: 20px;\n}\n\n.cs-list-icon {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cs-list-icon-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.cs-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.cs-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 400;\n  /* Regular */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n\n.cs-bullet {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 7px;\n}\n\n.cs-bullet-purple {\n  background-color: #6318C6;\n}\n\n.cs-bullet-orange {\n  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);\n}\n\n/* Solution */\n.cs-solution {\n  border-top: 1px solid #f0f0f0;\n  padding-top: 20px;\n}\n\n.cs-solution-label {\n  font-size: 16px;\n  font-weight: 600;\n  /* Semibold */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat-semibold, 'Montserrat', sans-serif);\n  display: block;\n  margin-bottom: 8px;\n}\n\n.cs-solution-text {\n  font-size: 16px;\n  font-weight: 400;\n  /* Regular */\n  color: #0D0D0D;\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  line-height: 1.65;\n  margin: 0;\n}\n\n/* ===========================\n   Responsive\n   =========================== */\n@media (max-width: 991px) {\n  .cs-image-wrap {\n    padding: 0px;\n    background: #fafafa;\n    border-bottom: 1px solid #f0f0f0;\n    min-height: auto;\n  }\n\n  .cs-content {\n    padding: 12px 10px 10px 10px;\n  }\n}\n\n@media (max-width: 767px) {\n  .cs-impact-title {\n    font-size: 16px;\n    margin-bottom: 5px !important;\n  }\n\n  .cs-lists-row {\n    margin-bottom: 10px;\n  }\n\n  .cs-solution-text {\n    font-size: 14px;\n  }\n\n  .cs-solution {\n    padding-top: 10px;\n  }\n\n  .cs-list {\n    padding: 0 0 0 25px;\n  }\n\n  .cs-badge {\n    margin-bottom: 11px;\n  }\n\n  .cs-list-heading {\n    margin-bottom: 10px;\n  }\n\n  .cs-card {\n    border: none;\n    box-shadow: none;\n  }\n\n  .cs-section {\n    padding: 50px 0 4px;\n  }\n\n  .cs-section-heading {\n    font-size: var(--font-size-regular);\n    margin-bottom: 24px;\n    text-align: center;\n  }\n\n  .cs-brand-name {\n    font-size: 20px;\n  }\n\n  .cs-brand-desc {\n    font-size: 14px;\n  }\n\n  .cs-impact-text {\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1280px) {\n  .cs-content {\n    padding: 24px 35px 20px 0px !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .cs-content {\n    padding: 24px 35px 20px 0px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
